module.exports = __webpack_public_path__ + "img/bg_miandian@2x.845b7d8c.png";